import gql from 'graphql-tag'

export const ADD_REUSE = gql`
    mutation(
    $name: String!
    $type: String!
    $laoName: String
    $score:Int
  ){
    addReuse( info:{
      name: $name
      type: $type
      laoName: $laoName
      score:$score
    }
      
    )
    {
      _id
      name
      laoName
    }
  }
  

`
export const GET_NEW_JOB_FUNCTION = gql`
 query (
  $search: String
  ) {	
    getParents(search:$search) {
		_id
		name
		laoName
		score
    isCheck
    status
		items {
			_id
			name
			laoName
      isCheck
			score
		}
	}
}

 `
export const GET_CHILD_JOB_FUNCTION = gql`
 {
	getClild {
		_id
		name
		laoName
		score
}
}
`
export const ADD_NEW_JOB_FUNCTION = gql` 

mutation(
    $pId: ID
    $_id: ID
    $name: String
    $status:Boolean
  ){
    addToParent(info:{
      pId:$pId
      _id:$_id 
      name: $name 
      status:$status
    })
  }

`

